/* ===== La Tocanterie — Accueil Épuré, vivant & immersif ===== */
(function(){
  "use strict";
  if(window.__ltLux) return; window.__ltLux = true;
  var d = document, root = d.documentElement;
  root.classList.add('lx-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function all(s){ return Array.prototype.slice.call(d.querySelectorAll(s)); }
  function clamp(x){ return x < 0 ? 0 : (x > 1 ? 1 : x); }
  function ease(x){ return 1 - Math.pow(1 - x, 3); }

  /* Vidéos */
  var videos = all('video.lx-cover');
  videos.forEach(function(v){
    v.muted = true; v.setAttribute('muted',''); v.setAttribute('playsinline','');
    if(reduce){ v.removeAttribute('autoplay'); try{ v.pause(); }catch(e){} }
  });

  /* Titres mot par mot */
  if(!reduce){
    all('.lx-h2').forEach(function(el){
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function(w, i){
        var o = d.createElement('span'); o.className = 'lx-w2';
        var s = d.createElement('span'); s.textContent = w; s.style.setProperty('--i', i);
        o.appendChild(s); el.appendChild(o);
        if(i < words.length - 1) el.appendChild(d.createTextNode(' '));
      });
      el.classList.add('lx-split');
    });
  }

  /* Apparitions en cascade */
  all('[data-lx-stagger]').forEach(function(p){
    Array.prototype.slice.call(p.children).forEach(function(el, i){ el.classList.add('lx-rv'); el.style.setProperty('--s', i); });
  });
  var targets = all('.lx-rv, [data-lx-reveal], .lx-split');

  if('IntersectionObserver' in window){
    if(!reduce){
      var vio = new IntersectionObserver(function(es){
        es.forEach(function(en){
          if(en.isIntersecting){ var p = en.target.play(); if(p && p.catch) p.catch(function(){}); }
          else { en.target.pause(); }
        });
      },{threshold:.05});
      videos.forEach(function(v){ vio.observe(v); });
    }
    var rio = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); rio.unobserve(en.target); } });
    },{threshold:.12, rootMargin:'0px 0px -8% 0px'});
    targets.forEach(function(el){ rio.observe(el); });
  } else {
    targets.forEach(function(el){ el.classList.add('in'); });
  }

  if(reduce) return;

  /* ---------- Effets liés au défilement ---------- */
  var bar = d.createElement('div'); bar.className = 'lx-progress'; bar.setAttribute('aria-hidden','true'); d.body.appendChild(bar);
  var hero = d.querySelector('.lx-hero');
  var heroIn = hero && hero.querySelector('.lx-hero-in');
  var heroMedia = hero && hero.querySelector('.lx-hero-media');
  var layers = all('[data-lx-parallax]').filter(function(el){ return el !== heroMedia; });
  var quote = d.querySelector('[data-lx-words]');
  var qw = quote ? Array.prototype.slice.call(quote.querySelectorAll('.lx-qw')) : [];
  var spins = all('[data-lx-spin]');
  var spots = all('[data-lx-spot]');
  var drifts = all('[data-lx-drift]');
  var cinemas = all('.lx-cinema');
  var mx = 0, my = 0;
  var ticking = false;

  function update(){
    var y = window.pageYOffset || root.scrollTop, vh = window.innerHeight;
    var max = root.scrollHeight - vh;
    bar.style.transform = 'scaleX(' + (max > 0 ? clamp(y / max) : 0).toFixed(4) + ')';

    if(hero && heroIn){
      var p = clamp(y / (hero.offsetHeight * .75));
      heroIn.style.opacity = (1 - p * 1.2).toFixed(3);
      heroIn.style.transform = 'translate3d(' + (mx * 8).toFixed(1) + 'px,' + (p * -80 + my * 6).toFixed(1) + 'px,0) scale(' + (1 - p * .04).toFixed(4) + ')';
      if(heroMedia) heroMedia.style.transform = 'translate3d(' + (mx * -18).toFixed(1) + 'px,' + (y * .3 + my * -14).toFixed(1) + 'px,0) scale(' + (1.03 + p * .08).toFixed(4) + ')';
    }

    layers.forEach(function(el){
      var r = el.parentElement.getBoundingClientRect();
      if(r.bottom < 0 || r.top > vh) return;
      var prog = (r.top + r.height / 2 - vh / 2) / vh;
      var sc = el.hasAttribute('data-lx-zoom') ? ' scale(' + (1 + Math.min(Math.abs(prog), 1) * .18).toFixed(4) + ')' : '';
      el.style.transform = 'translate3d(0,' + (prog * -9).toFixed(2) + '%,0)' + sc;
    });

    cinemas.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.bottom < 0 || r.top > vh) return;
      var c = 1 - ease(clamp((vh - r.top) / (vh * .85)));
      el.style.clipPath = 'inset(' + (c * 8).toFixed(2) + '% ' + (c * 10).toFixed(2) + '% round ' + (c * 32).toFixed(1) + 'px)';
    });

    if(quote && qw.length){
      var qr = quote.getBoundingClientRect();
      var n = clamp((vh * .85 - qr.top) / (vh * .5)) * qw.length;
      qw.forEach(function(w, i){
        var k = clamp(n - i);
        w.style.opacity = (.14 + .86 * k).toFixed(3);
        w.style.transform = 'translate3d(0,' + ((1 - k) * 10).toFixed(1) + 'px,0)';
      });
    }

    spots.forEach(function(el){
      var r = el.getBoundingClientRect();
      var total = el.offsetHeight - vh;
      if(total <= 0 || r.bottom < -vh || r.top > vh * 1.5) return;
      var sp = clamp((vh * .35 - r.top) / (total + vh * .35));
      el.style.setProperty('--p', sp.toFixed(4));
      el.style.setProperty('--a', ease(clamp(sp / .45)).toFixed(4));
      el.style.setProperty('--b', ease(clamp((sp - .42) / .28)).toFixed(4));
    });

    drifts.forEach(function(el){
      var r = el.parentElement.getBoundingClientRect();
      if(r.bottom < 0 || r.top > vh) return;
      var prog = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(' + (-25 + prog * 22).toFixed(2) + '%,-50%,0)';
    });

    spins.forEach(function(el){ el.style.transform = 'rotate(' + (y * .12).toFixed(1) + 'deg)'; });
    ticking = false;
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  update();

  /* ---------- Curseur doré + héros qui suit la souris (ordinateur) ---------- */
  if(fine){
    var ring = d.createElement('div'); ring.className = 'lx-cursor';
    var dot = d.createElement('div'); dot.className = 'lx-cursor-dot';
    d.body.appendChild(ring); d.body.appendChild(dot);
    var tx = -100, ty = -100, rx = -100, ry = -100, tmx = 0, tmy = 0;
    d.addEventListener('mousemove', function(e){
      tx = e.clientX; ty = e.clientY;
      tmx = (e.clientX / window.innerWidth - .5) * 2;
      tmy = (e.clientY / window.innerHeight - .5) * 2;
      ring.classList.add('on'); dot.classList.add('on');
    }, {passive:true});
    d.addEventListener('mouseleave', function(){ ring.classList.remove('on'); dot.classList.remove('on'); });
    d.addEventListener('mouseover', function(e){
      var t = e.target.closest && e.target.closest('a, button, input, .pcard');
      ring.classList.toggle('big', !!t);
    });
    (function loop(){
      rx += (tx - rx) * .16; ry += (ty - ry) * .16;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      dot.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
      var nmx = mx + (tmx - mx) * .06, nmy = my + (tmy - my) * .06;
      if(Math.abs(nmx - mx) > .0005 || Math.abs(nmy - my) > .0005){ mx = nmx; my = nmy; if(hero && (window.pageYOffset || 0) < window.innerHeight) onScroll(); }
      requestAnimationFrame(loop);
    })();
  }
})();
